import React from 'react';
import { Container, Input, Label } from './InputEditorElements';

const InputEditor = ({ ref, label, type, style, onChange = () => { }, name = "", value }) => {

    return (
        <Container style={style}>
            <Input ref={ref} type={type} placeholder=" " onChange={onChange} name={name} value={value} />
            <Label>{label}</Label>
        </Container>
    )
}

export default InputEditor;